import { createContext, useContext, type ReactNode } from "react";

export interface GameConfig {
  showSponsor: () => boolean;
}

function showSponsor(): boolean {
  const now = new Date();
  // Start: June 1, 2026 at midnight ET (EDT = UTC-4)
  const start = new Date("2026-06-01T00:00:00-04:00");
  // End: June 30, 2026 at midnight ET (i.e. end of June 30)
  const end = new Date("2026-06-30T24:00:00-04:00");

  return now >= start && now < end;
}

export const defaultConfig: GameConfig = {
  showSponsor,
};

const GameConfigContext = createContext<GameConfig>(defaultConfig);

export function GameConfigProvider({
  children,
  config = defaultConfig,
}: {
  children: ReactNode;
  config?: GameConfig;
}) {
  return (
    <GameConfigContext.Provider value={config}>
      {children}
    </GameConfigContext.Provider>
  );
}

export function useGameConfig(): GameConfig {
  return useContext(GameConfigContext);
}
